import {FunctionalModal} from "./FunctionalModal";
import React from "react";
import styled from "styled-components";
import {BlueButton, BlueReverseButton} from "../buttons/ButtonStyles";
import {BaseModal} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";

const WhereToEditProjectModal = ({setOpenModal, handleNavigation}) => {

    const close = () => {
        setOpenModal(false)
    }
    const displayModal = () => {
        return (
            <Modal>
                <FirstSection>
                    <h5 className={"mar-bot-05 txt-align"}> Mon projet avance 🚀 </h5>
                    <ExitButton
                        closeUpdate={close}
                    />
                </FirstSection>

                <ButtonsContainer>
                    <ToGuidedUpdateBtn id={'yes'} onClick={() => handleNavigation('guided-update')}>
                        <p> Je me laisse guider </p>
                    </ToGuidedUpdateBtn>
                    <ToFormButton id={'no'} onClick={() => handleNavigation('edit-form')}>
                        <p> Je paramètre mon projet </p>
                    </ToFormButton>
                </ButtonsContainer>
            </Modal>
        )

    }
    return (
        <FunctionalModal setOpen={setOpenModal} component={displayModal()}/>

    )
}

const Modal = styled(BaseModal)`
  gap: 1rem;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 2em;
  width: 80vw;
  height: fit-content;
  @media (min-width: 768px) {
    width: 500px;
  }
`

const FirstSection = styled.div`
  display: flex;

  h5 {
    flex-grow: 1;
  }

  .exit-btn {
    transform: translateY(-50%);
  }`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 1rem;
`
const ToGuidedUpdateBtn = styled(BlueButton)`
  padding: 0.5rem;
  width: 50%;
`

const ToFormButton = styled(BlueReverseButton)`
  flex-grow: 1;
  width: 50%;
`


export default WhereToEditProjectModal